// React
import { Link } from 'react-router-dom';

// Utils
import cn from '@/utils/cn';

// Assets
import Facebook from '@/assets/images/socials/facebook.svg?react';
import X from '@/assets/images/socials/x.svg?react';
import Instagram from '@/assets/images/socials/instagram.svg?react';
import Linkedin from '@/assets/images/socials/linkedin.svg?react';
import Youtube from '@/assets/images/socials/youtube.svg?react';

// Types
import { FooterType } from '@/components/organisms/Footer/FooterType';

// Styles
import styles from './SocialLinks.module.css';

interface SocialLinksProps {
  links: FooterType['socialMedia'];
  color?: 'black' | 'white';
  className?: string;
}

function SocialLinks({ links = null, color = 'black', className = '' }: SocialLinksProps) {
  const renderIcon = (type: string): React.ReactNode => {
    switch (type) {
    case 'facebook':
      return <Facebook />;
    case 'x':
      return <X />;
    case 'instagram':
      return <Instagram />;
    case 'linkedin':
      return <Linkedin />;
    case 'youtube':
      return <Youtube />;
    default:
      return null;
    }
  };

  return (
    <div className={cn([styles.socials, styles[color], className])}>
      {links && links.length > 0
        ? links.map((link) => (
          <Link
            key={`${link.id}-${link.type}`}
            to={link.link}
            target="_blank"
            rel="noopener noreferrer"
            title={link.type}
            aria-label={`Suivez-nous sur ${link.type}`}
          >
            {renderIcon(link.type)}
          </Link>
        ))
        : null}
    </div>
  );
}

export default SocialLinks;
